import React from 'react';
import ChartBox from '../../Custom/ChartBox';
import ChartPowerFlowHistorical from './ChartPowerFlowHistorical';

const PowerFlowHistorical = ({ data }) => (
  <div>
    <ChartBox title={'Power Flow Historical'}>
      <ChartPowerFlowHistorical data={data} />
    </ChartBox>
  </div>
);

export default PowerFlowHistorical;
